exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "hr{border-color:#c5c5c5;margin-bottom:30px;margin-top:0}", ""]);

